import React, { FunctionComponent, useContext, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { FocusableHeader, CountyPicker } from "../../components";
import { useTranslate, useQueryParams } from "../../helpers";
import { County, ActionType } from "../../@types";
import { AppContext } from "../../app/store";
import { Routes } from "../../app";
import { Button } from "@cmsgov/ds-medicare-gov";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../app/contexts/Analytics/types";

const CoverageWizardLandingPage: FunctionComponent<RouteComponentProps> = props => {
  const t = useTranslate();
  const { dispatch, state } = useContext(AppContext);
  const { fips, zipcode } = state;
  const [formValues, setFormValues] = useState<{
    county?: County;
    zipcode?: string;
    fips?: string;
  }>({});

  useQueryParams(props);

  const onCountySelect = (county?: County, zipcode?: string): void => {
    setFormValues(previousValues => ({
      ...previousValues,
      county,
      zipcode,
      fips: county?.fips,
    }));
  };

  const onNext = () => {
    dispatch({ type: ActionType.UPDATE_COUNTY, payload: formValues.county });
    dispatch({
      type: ActionType.UPDATE_FIPS,
      payload: formValues.fips,
    });
    dispatch({
      type: ActionType.UPDATE_ZIPCODE,
      payload: formValues.zipcode,
    });
    dispatch({
      type: AnalyticsActionType.SEND_TEALIUM_EVENT,
      settings: {
        event_action: "Coverage Wizard - Landing",
        event_label: "Next",
      },
    });
    dispatch({
      type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
      settings: {
        button: {
          buttonStyle: AnalyticsButtonStyle.PRIMARY,
          buttonType: AnalyticsButtonType.BUTTON,
          text: t("next"),
        },
        linkUrl: Routes.coverageWizard.options,
      },
    });
    props.history.push(Routes.coverageWizard.options);
  };

  return (
    <div className="CoverageWizardLandingPage">
      <div className="CoverageWizardLandingPage__hero">
        <div className="CoverageWizardLandingPage__heroContent">
          <FocusableHeader
            className="CoverageWizardLandingPage__heroHeader"
            text={t("coveragewizard.landing.header")}
            ignoreFocus={false}
          />
          <div className="CoverageWizardLandingPage__heroSubheader">
            {t("coveragewizard.landing.subheader")}
            <br />
            {t("coveragewizard.landing.subheader_2")}
          </div>
        </div>
      </div>

      <div className="CoverageWizardLandingPage__content">
        <div className="CoverageWizardLandingPage__card">
          <div>
            <CountyPicker
              className="CoverageWizardLandingPage__statePicker"
              label={t("coveragewizard.landing.enter_zip")}
              onCountySelect={onCountySelect}
              initialFips={fips}
              initialZip={zipcode}
              buttonLabel={t("start")}
              buttonCallback={() =>
                dispatch({
                  type: AnalyticsActionType.SEND_TEALIUM_EVENT,
                  settings: {
                    event_action: "Coverage Wizard - Landing",
                    event_label: "Enter Zip Code",
                  },
                })
              }
            />

            {formValues.county && (
              <Button
                variation="solid"
                className="ds-u-margin-top--2 e2e-coverage-wizard-next"
                size="big"
                onClick={onNext}
              >
                {t("next")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(CoverageWizardLandingPage);
